define([
    "dojo/_base/lang",
    "../../../constants/TypeConstants",
    "../properties/TypeProperty",
    "../properties/TagProperty",
    "../properties/IconProperty",
    "../properties/IconOverrideProperty",
    "../properties/QuickAccessIconProperty",
    "../properties/TextProperty",
    "../properties/TextOverrideProperty",
    "../properties/EnabledProperty",
    "../properties/DescriptionProperty",
    "../properties/DescriptionOverrideProperty",
    "../properties/MnemonicProperty",
    "../properties/ActionIdProperty",
    "../properties/IsInQABProperty"
    
], function(lang, TypeConstants, TypeProperty, TagProperty, IconProperty, IconOverrideProperty, QuickAccessIconProperty, TextProperty, TextOverrideProperty, EnabledProperty,
            DescriptionProperty, DescriptionOverrideProperty, MnemonicProperty, ActionIdProperty, IsInQABProperty ) {

    
    var hash ={};
    
    hash[TypeConstants.GRID_PICKER_BUTTON] = lang.mixin({}, {

        maxRows: {
            type: "number",
            defaultValue: 5,
            notInAction: true,
            required: false
        },

        maxColumns: {
            type: "number",
            defaultValue: 5,
            notInAction: true,
            required: false
        },

        occupancy: {
            type: "number",
            defaultValue: 0,
            notInAction: true,
            required: false
        },

        fillOrder: {
            type: "string",
            defaultValue: "rowMajor",
            notInAction: true,
            required: false
        },

        selection: {
            type: "Object",
            defaultValue: {},
            notInAction: true,
            required: false
        }
    }, TypeProperty, TagProperty, IconProperty, IconOverrideProperty, QuickAccessIconProperty, TextProperty, TextOverrideProperty, EnabledProperty,
        DescriptionProperty, DescriptionOverrideProperty, MnemonicProperty, ActionIdProperty, IsInQABProperty);

    return hash;
});